export enum LocalStorageItem {
  IS_SIDEBAR_CONDENSED = 'isSideBarCondensed',
}
